import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//IMPORTS
import App from "../containers/app";
import routes from "../constants/routes";
import HomeRoute from "./home";
import LoginRoute from "./login";
import DepositRoute from "./deposit";
import { ProductRoute } from "./product";
import PricesRoute from "./prices";
import InventaryRoute from "./inventary";
import {
  DepositChangesRoute,
  OrderChangesRoute,
  SettingsChangesRoute,
} from "./changesRecords";
import {
  ServicesRoute,
  ViewServicesRoute,
  ServiceUsersRoute,
} from "./services";
import GeneralSettingsRoute from "./generalSettings";
import ShippingSettingsRoute, {
  ShippingModuleRoute,
  ViewShippingModuleRoute,
  ShippingPreferenceRoute,
} from "./shippingSettings";
import PickersSettingsRoute from "./pickersSettings";
import GoogleSettingsRoute from "./googleSettings";
import { MercadopagoPaymentSettingsRoute } from "./paymentsSettings";
import UsersRoute from "./users";
import { ViewDiscountRoute, DiscountMarketingRoute } from "./discountMarketing";
import { ViewCouponRoute, CouponMarketingRoute } from "./couponMarketing";
import { ViewEmailRoute, EmailMarketingRoute } from "./emailMarketing";
import { OrdersRoute, OrderInfoRoute, CreateOrderRoute } from "./orders";
import WebRoute from "./web";
import CustomerServiceRoute, {
  CustomerServiceInfoRoute,
} from "./customerService";
import EmailSettingsRoute from "./emailSettings";
import ResetPasswordRoute from "./resetPassword";
import NotMatchRoute from "./notMatch";
import BsaleRoute from "./bsaleSettings";
import SubsidiaryRoute from "./subsidiary";
import ModuleWebRoute from "./moduleWeb";
import DndRoute from "./dnd";
import PlansRoute from "./plans";
import MarketingIntegrationsRoute from "./marketingIntegrations";
import MenuRoute from "./menu";
import QrSurveyRoute from "./qrsurvey";
import CompanyPaymentSettingsRoute from "./companyPaymentSettings";
import {
  MailChimpMarketingRoute,
  NewTemplateMailChimpMarketingRoute,
  NewCampaignMailChimpMarketingRoute,
} from "./mailChimpMarketing";
import BookingsRoute from "./booking";
import SalesRoute from "./sales";
import SubsidiaryInfoRoute from "./subsidiaryInfo";
import FacebookComponent from "../components/marketing/integrations/facebook";
import FudoComponent from "../components/marketing/integrations/fudo";
import GoogleAnalytics from "../components/marketing/integrations/google/analytics";
import GoogleTagManager from "../components/marketing/integrations/google/tagManager";
import IngefacturaComponent from "../components/marketing/integrations/ingefactura";
import SimphonyOracleComponent from "../components/marketing/integrations/oracle/simphony";
import ToteatComponent from "../components/marketing/integrations/toteat";
import GetnetPaymentSettings from "../components/settings/payments/getnetPaymentSettings";
import MercadoPagoPaymentSettings from "../components/settings/payments/mercadoPagoPaymentSettings";
import Pedidosya from "../components/settings/shippingFulfillment/pedidosya";
import Cabify from "../components/settings/shippingFulfillment/cabify";
import Uber from "../components/settings/shippingFulfillment/uber";
import MailChimpComponent from "../components/marketing/integrations/mailchimp";
import WebhookRoute from "./webhook";
import WebPayPaymentSettings from "../components/settings/payments/webPay/webPayPaymentSettings";
import FintocPaymentSettings from "../components/settings/payments/fintoc/fintocPaymentSettings";
import EdenredPaymentSettings from "../components/settings/payments/edenred/edenredPaymentSettings";
import AmipassPaymentSettings from "../components/settings/payments/amipass/amipassPaymentSettings";
import StoreSettingsRoute from "./storeSettings";
import MassiveChangeRoute from "./massiveChange";
import MyShipmentRoute from "./myshipment";

export default function RoutesComponent(props) {
  return (
    <Router>
      <App>
        <Routes>
          <Route exact path={`${routes.SALES.path}`} element={<SalesRoute />} />
          <Route
            exact
            path={`${routes.MAILCHIMP_MARKETING.path}`}
            element={<MailChimpMarketingRoute />}
          />
          <Route
            exact
            path={`${routes.MAILCHIMP_MARKETING.path}/:index`}
            element={<MailChimpMarketingRoute />}
          />
          <Route
            exact
            path={`${routes.MAILCHIMP_MARKETING.path}/campaigns/new`}
            element={<NewCampaignMailChimpMarketingRoute />}
          />
          <Route
            exact
            path={`${routes.MAILCHIMP_MARKETING.path}/campaigns/update`}
            element={<NewCampaignMailChimpMarketingRoute />}
          />
          <Route
            exact
            path={`${routes.MAILCHIMP_MARKETING.path}/templates/new`}
            element={<NewTemplateMailChimpMarketingRoute />}
          />
          <Route
            exact
            path={`${routes.MAILCHIMP_MARKETING.path}/templates/update`}
            element={<NewTemplateMailChimpMarketingRoute />}
          />
          <Route
            exact
            path={routes.SHIPPING_PREFERENCE.path}
            element={<ShippingPreferenceRoute />}
          />
          <Route
            exact
            path={routes.QR_SURVEY.path}
            element={<QrSurveyRoute />}
          />
          <Route
            exact
            path={routes.MYSHIPMENT.path}
            element={<MyShipmentRoute />}
          />
          <Route exact path={routes.LOGIN.path} element={<LoginRoute />} />
          <Route exact path={"/test/dnd"} element={<DndRoute />} />
          <Route
            exact
            path={routes.RESETPASSWORD.path}
            element={<ResetPasswordRoute />}
          />
          <Route
            exact
            path={routes.BOOKINGS.path}
            element={<BookingsRoute />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_FACEBOOK_PIXEL.path}
            element={<FacebookComponent />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_FUDO.path}
            element={<FudoComponent />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_GOOGLE_ANALYTICS.path}
            element={<GoogleAnalytics />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_GOOGLE_TAG_MANAGER.path}
            element={<GoogleTagManager />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_INGEFACTURAS.path}
            element={<IngefacturaComponent />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_MAILCHIMP.path}
            element={<MailChimpComponent />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_ORACLE.path}
            element={<SimphonyOracleComponent />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_TOTEAT.path}
            element={<ToteatComponent />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_GETNET.path}
            element={<GetnetPaymentSettings />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_WEBPAY.path}
            element={<WebPayPaymentSettings />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_FINTOC.path}
            element={<FintocPaymentSettings />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_EDENRED.path}
            element={<EdenredPaymentSettings />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_AMIPASS.path}
            element={<AmipassPaymentSettings />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_MERCADOPAGO.path}
            element={<MercadoPagoPaymentSettings />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_PEDIDOSYA.path}
            element={<Pedidosya />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_CABIFY.path}
            element={<Cabify />}
          />{" "}
          <Route
            exact
            path={routes.INTEGRATIONS_UBER.path}
            element={<Uber />}
          />
          <Route
            exact
            path={`${routes.COMPANY_PAYMENTS_SETTINGS.path}`}
            element={<CompanyPaymentSettingsRoute />}
          />
          <Route exact path={`${routes.MENU.path}`} element={<MenuRoute />} />
          <Route
            exact
            path={`${routes.EMAIL_SETTINGS.path}`}
            element={<EmailSettingsRoute />}
          />
          <Route
            exact
            path={`${routes.SUBSIDIARIES.path}`}
            element={<SubsidiaryRoute />}
          />
          <Route
            exact
            path={`${routes.SUBSIDIARIES_INFO.path}`}
            element={<SubsidiaryInfoRoute />}
          />
          <Route
            exact
            path={`${routes.INTEGRATIONS_SHIPPING_MODULE.path}/:id`}
            element={<ViewShippingModuleRoute />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_SHIPPING_MODULE.path}
            element={<ShippingModuleRoute />}
          />
          <Route
            exact
            path={routes.CUSTOMER_SERVICE.path}
            element={<CustomerServiceRoute />}
          />
          <Route
            exact
            path={routes.CUSTOMER_SERVICE_REQUEST_INFO.path}
            element={<CustomerServiceInfoRoute />}
          />
          <Route exact path={routes.WEB.path} element={<WebRoute />} />
          <Route
            exact
            path={routes.STORE_SETTINGS.path}
            element={<StoreSettingsRoute />}
          />
          <Route exact path={routes.ORDERS.path} element={<OrdersRoute />} />
          <Route
            exact
            path={`${routes.ORDER_INFO.path}/:orderID`}
            element={<OrderInfoRoute />}
          />
          <Route
            exact
            path={routes.CREATE_ORDER.path}
            element={<CreateOrderRoute />}
          />
          <Route
            exact
            path={routes.NEW_EMAIL_MARKETING.path}
            element={<ViewEmailRoute />}
          />
          <Route
            exact
            path={`${routes.EMAIL_MARKETING.path}/ver`}
            element={<ViewEmailRoute />}
          />
          <Route
            exact
            path={routes.EMAIL_MARKETING.path}
            element={<EmailMarketingRoute />}
          />
          <Route
            exact
            path={routes.EMAIL_MARKETING.path}
            element={<EmailMarketingRoute />}
          />
          <Route
            exact
            path={routes.NEW_DISCOUNT_MARKETING.path}
            element={<ViewDiscountRoute mode="new" />}
          />
          <Route
            exact
            path={routes.NEW_COUPON_MARKETING.path}
            element={<ViewCouponRoute mode="new" />}
          />
          <Route
            exact
            path={`${routes.DISCOUNT_MARKETING.path}/ver`}
            element={<ViewDiscountRoute />}
          />
          <Route
            exact
            path={`${routes.COUPON_MARKETING.path}/ver`}
            element={<ViewCouponRoute />}
          />
          <Route
            exact
            path={routes.DISCOUNT_MARKETING.path}
            element={<DiscountMarketingRoute />}
          />
          <Route
            exact
            path={routes.COUPON_MARKETING.path}
            element={<CouponMarketingRoute />}
          />
          <Route exact path={routes.USERS.path} element={<UsersRoute />} />
          <Route
            exact
            path={routes.MERCADOPAGO_PAYMENTS.path}
            element={<MercadopagoPaymentSettingsRoute />}
          />
          <Route
            exact
            path={routes.BSALE_SETTINGS.path}
            element={<BsaleRoute />}
          />
          <Route
            exact
            path={routes.PICKERS_SETTINGS.path}
            element={<PickersSettingsRoute />}
          />
          <Route
            exact
            path={routes.SHIPPING_SETTINGS.path}
            element={<ShippingSettingsRoute />}
          />
          <Route
            exact
            path={routes.GOOGLE_SETTINGS.path}
            element={<GoogleSettingsRoute />}
          />
          <Route
            exact
            path={routes.GENERAL_SETTINGS.path}
            element={<GeneralSettingsRoute />}
          />
          <Route
            exact
            path={routes.SERVICES.path}
            element={<ServicesRoute />}
          />
          <Route
            exact
            path={`${routes.SERVICES.path}/ver`}
            element={<ViewServicesRoute />}
          />
          <Route
            exact
            path={routes.SERVICES_USER.path}
            element={<ServiceUsersRoute />}
          />
          <Route
            exact
            path={routes.NEW_SERVICES.path}
            element={<ViewServicesRoute />}
          />
          <Route
            exact
            path={routes.ORDERS_CHANGES.path}
            element={<OrderChangesRoute />}
          />
          <Route
            exact
            path={routes.SETTINGS_CHANGES.path}
            element={<SettingsChangesRoute />}
          />
          <Route
            exact
            path={routes.DEPOSIT_CHANGES.path}
            element={<DepositChangesRoute />}
          />
          <Route
            exact
            path={routes.INVENTARY.path}
            element={<InventaryRoute />}
          />
          <Route exact path={routes.PRICES.path} element={<PricesRoute />} />
          <Route
            exact
            path={`${routes.DEPOSIT.path}/crear`}
            element={<ProductRoute />}
          />
          <Route
            exact
            path={`${routes.DEPOSIT.path}/modificar/:productID`}
            element={<ProductRoute />}
          />
          <Route exact path={routes.DEPOSIT.path} element={<DepositRoute />} />
          <Route
            exact
            path={`${routes.DEPOSIT.path}/cambios-masivos`}
            element={<MassiveChangeRoute />}
          />
          <Route exact path={routes.HOME.path} element={<HomeRoute />} />
          <Route
            exact
            path={routes.MODULE_WEB.path}
            element={<ModuleWebRoute />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_NATIVE.path}
            element={<MarketingIntegrationsRoute />}
          />
          <Route
            exact
            path={routes.INTEGRATIONS_EXTERNAL_APPS.path}
            element={<WebhookRoute />}
          />
          <Route exact path={routes.PLANS.path} element={<PlansRoute />} />
          <Route path="*" element={<NotMatchRoute />} />
        </Routes>
      </App>
    </Router>
  );
}
